// generated by srcset-codegen
import src from "./table.svg";

const width = 16;
const height = 13;
export default { src, width, height };
